import { JSX } from "react";
import { ProductSpecificationEntry } from "../../utils/dstProductDetailAdapters";
import { ProductSpecificationAttributeValue } from "./ProductSpecificationAttributeValue";

interface Props {
    entry: ProductSpecificationEntry;
}

export const ProductSpecificationItem = ({ entry }: Props): JSX.Element => (
    <div className="c-product-specs__item">
        <div className="item-text-header">{entry.label}</div>
        <div className="item-text-beverages">
            {entry.dimensionsValue != null ? (
                entry.dimensionsValue
            ) : entry.attribute ? (
                <ProductSpecificationAttributeValue
                    attribute={entry.attribute}
                />
            ) : null}
        </div>
    </div>
);
